<template>
<transition name="gi-nav-fade">
  <!-- <div class="gi-nav is-fix" :class="{'is-show':ready}" v-show="!transparent"> -->
  <div class="gi-nav-mobile is-fix" :class="{'is-show':ready}">
    <div class="gi-nav-container">
      <div class="nav-item">
        <a class="logo" style="position:relative; width: 207px;"><img :src="logo" /></a>
      </div>
      <div class="nav-right">
        <div class="nav-item" @click="showMobileMenu = !showMobileMenu">
          <a class="gi-nav-hamburger" :class="{'is-active': showMobileMenu}"><i></i><i></i><i></i></a>
        </div>
      </div>
    </div>

    <transition name="gi-nav-fade">
      <div class="nav-menu is-mobile" v-show="showMobileMenu">
        <ul class="list">
          <div class="list-wrapper">
            <a v-for="m in navData" class="item" :key="m.id" @click="changeNav(m.name)">
              <span v-if="!m.children">{{m.title}}</span>
              <a class="item-children" v-for="(item, index) in m.children" :key="index" @click="changeNav(item.name)">{{item.title}}</a>
            </a>
            <a v-if="isEnLang" class="item" @click="changeLang('zh-CN')" style="color: #2b70fb">{{linkText}}</a>
          </div>
          <!-- <a v-else class="item" @click="changeLang('en-US')" style="color: #2b70fb">{{linkText}}</a> -->
          <!-- <a class="register-now" href="https://www.infoq.cn/form/?id=1139">马上报名</a> -->
          <a class="register-now" href="/zones/fintechathon/campus2022/awards">入围名单</a>
        </ul>
      </div>
    </transition>
  </div>
</transition>

</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  props: ['navData', 'logo'],
  data () {
    return {
      showMobileMenu: false,
      scrollTop: 0,
      screenWidth: 0,
      ready: false,
      lingText: 'ENGLISH'
    }
  },
  created () {
  },
  methods: {
    ...mapActions(['setLang']),
    changeNav (name) {
      this.showMobileMenu = false
      this.$emit('changeNav', {name: name, isMobile: true})
    },
    changeLang (val) {
      // this.lingText = !this.isLangEn ? '中文版' : 'ENGLISH'
      // console.log(this.lingText)
      // const lang = this.isLangEn ? 'zh-CN' : 'en-US'
      this.setLang(val)
    }
  },
  computed: {
    ...mapState(['isEnLang']),
    linkText () {
      return this.isEnLang ? '中文版' : 'ENGLISH'
    }
  }
}
</script>

<style lang="sass">
// nav
//  container
//    nav-left, nav-middle, nav-right
//      nav-item
//        logo
//          img
//        hanburger
//        nav-menu.is-tablet
//  nav-menu.is-mobile

$nav-container-width: 1100px
$nav-container-width-m: 92vw
$nav-primary: #1075d4
$nav-height-mobile: 55px
$nav-height-tablet: 65px
$nav-hamburger-size: 25px
$nav-menu-tablet-margin: 0
$nav-menu-mobile-padding: 4vw
$nav-bg: rgba(19,16,26,0.9)
$nav-text: #fff
$nav-link: #1075d4
$nav-text-size: 16px
$nav-z-index: 1000
$nav-speed: .3s

=mobile
  @media screen and (max-width: 768px)
    @content

=tablet
  @media screen and (min-width: 769px)
    @content

.gi-nav-hamburger
  cursor: pointer
  display: block
  height: 18px
  width: 18px
  display: flex
  flex-direction: column
  justify-content: space-between
  i
    display: block
    height: 2px
    width: 100%
    background-color: #000000
    transition: all $nav-speed ease-out
  &.is-active
    i
      &:nth-child(1)
        width: 23.2px
        transform: rotate(47deg)
        transform-origin: left top
      &:nth-child(2)
        opacity: 0
      &:nth-child(3)
        width: 23.2px
        transform: rotate(-47deg)
        transform-origin: left bottom

.gi-nav-container
  width: $nav-container-width
  +mobile
    width: $nav-container-width-m
  margin: 0 auto
  display: flex
  justify-content: space-between
  height: 100%

.gi-nav-fade-enter-active, .gi-nav-fade-leave-active
  transition: opacity $nav-speed
.gi-nav-fade-enter, .gi-nav-fade-leave-to
  opacity: 0

.register-now
  display: inline-block
  position: absolute
  bottom: 0
  width: 170px
  height: 40px
  text-align: center
  color: #FFFFFF
  background: #DD3840
  line-height: 40px

.item
  display: flex
  flex-direction: column
  align-items: center

.gi-nav-mobile
  display: flex
  justify-content: space-between
  z-index: $nav-z-index
  white-space: nowrap
  background-color: #FFFFFF
  height: $nav-height-mobile
  &.is-fix
    position: fixed
    left: 0
    width: 100vw
    top: 0
    .nav-menu.is-mobile
      position: fixed
      display: flex
      justify-content: center
  .nav-left, .nav-middle, .nav-right, .nav-item, .nav-menu.is-tablet
    display: flex
    height: 100%
    flex-grow: 0
    flex-shrink: 0

  .nav-item
    align-items: center

  .logo
    display: flex
    height: 50%
    align-items: center
    margin-right: 10px
    a
      display: inline-flex
      height: 100%
    img
      width: 100%
  .nav-menu a
    // color: $nav-text
    font-size: $nav-text-size
    &:hover
      color: $nav-link
  .nav-menu.is-tablet
    margin: $nav-menu-tablet-margin

    a:not(:first-child)
      margin-left: 30px

    .nav-item
      position: relative

    .nav-item::after
      content: ''
      position: absolute
      left: 0
      right: 0
      bottom: 0
      height: 4px
      transition: background $nav-speed
      background-color: #000

    .nav-item:hover::after
      background-color: $nav-primary

  .nav-menu.is-mobile
    z-index: $nav-z-index
    position: fixed
    left: 0
    top: $nav-height-mobile
    bottom: 0
    width: 100%
    height: 500px
    padding: $nav-menu-mobile-padding
    // background-color: $nav-bg
    overflow-y: auto
    background-color: #FFFFFF

    .list
      position: relative
      display: flex
      flex-direction: column
      align-items: center
      width: 100%

    .list-wrapper
      width: 100%
      height: 420px
      overflow-y: auto

    .list > .item
      display: flex
      padding: 18px 0
      font-size: $nav-text-size
      line-height: 1
      // border-bottom: 1px solid rgba(255,255,255,.25)
    .item
      padding: 9px 0
      text-align: center

      &:nth-child(n+3)
        padding: 0

    .item-children
      padding: 9px 0
      color: #000000
      +mobile
        width: 100%
  +mobile
    .nav-menu.is-tablet
      display: none
</style>
